import React from 'react'
import { Input, FormGroup, Label } from 'reactstrap'
import { ReactComponent as Lock } from "../../../../images/lock.svg"
import { ReactComponent as Unlock } from "../../../../images/unlock.svg"
const PricingField = (props:any) => {
  const {label,pricingValue,input,rate,lock,disable} = props
  return (
    <div className="fieldContainer">
      <FormGroup className={`field ${lock ? "lockField" : ""}`}>
        <Label className="label">
            {label}<span className="rate">{rate}</span>
        </Label>
        <Input
          disabled={lock ? lock : disable}
          className="input"
          {...input}
        />
      </FormGroup>
      <div className={`unlockContainer ${lock ? "lockContainer" : ""}`}>
        {lock ? <Lock className="image"/> : <Unlock className="image" />}
      </div>
    </div>
  )
}

export default PricingField